exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._breadcrumb__breadcrumb__1LWtA {\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  list-style: none;\n  background-color: #eceeef;\n  border-radius: 0.25rem; }\n\n._breadcrumb__breadcrumb-item__21aQq {\n  display: inline-block; }\n  ._breadcrumb__breadcrumb-item__21aQq + ._breadcrumb__breadcrumb-item__21aQq::before {\n    display: inline-block;\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n    color: #818a91;\n    content: \"/\"; }\n  ._breadcrumb__breadcrumb-item__21aQq + ._breadcrumb__breadcrumb-item__21aQq:hover::before {\n    text-decoration: underline; }\n  ._breadcrumb__breadcrumb-item__21aQq + ._breadcrumb__breadcrumb-item__21aQq:hover::before {\n    text-decoration: none; }\n  ._breadcrumb__breadcrumb-item__21aQq._breadcrumb__active__31zsJ {\n    color: #818a91;\n    font-weight: bold; }\n", ""]);

// exports
exports.locals = {
	"breadcrumb": "_breadcrumb__breadcrumb__1LWtA",
	"breadcrumb-item": "_breadcrumb__breadcrumb-item__21aQq",
	"active": "_breadcrumb__active__31zsJ"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]__[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/rctui/styles/_breadcrumb.scss
// module id = 381
// module chunks = 0 1